import { stdnum } from 'stdnum';

const COUNTRIES_WITH_TAX_ID = ['BR', 'CL', 'MX', 'AR'];

export const getIfTaxIdIsRequired = (countryCode) => {
  return COUNTRIES_WITH_TAX_ID.includes(countryCode);
};

export const validateTaxId = (taxId, countryCode) => {
  if (countryCode === 'BR') {
    const { isValid } = stdnum.BR.cpf.validate(taxId);

    return isValid;
  }

  if (countryCode === 'CL') {
    const { isValid } = stdnum.CL.rut.validate(taxId);

    return isValid;
  }

  if (countryCode === 'MX') {
    const { isValid } = stdnum.MX.rfc.validate(taxId);

    return isValid;
  }

  if (countryCode === 'AR') {
    const { isValid } = stdnum.AR.cuit.validate(taxId);

    return isValid;
  }

  return true;
};
